module.exports = __webpack_public_path__ + "img/irisSystem.26c4da29.png";